import { apiGet, apiDelete, apiPost, apiPut } from './api_call/api_methods'
import { getHeaders } from './common';

export const fetchAdmins = async () => {
    return apiGet({ endpoint: `${process.env.REACT_APP_API_URL}/admins`, error_message: "Failed to fetch admins." });
};

export const inviteAdmin = async (adminData) => {
    try {
        const response = await fetch(
            `${process.env.REACT_APP_API_URL}/invite-admin`,
            {
                method: "POST",
                headers: getHeaders(),
                body: JSON.stringify(adminData),
                credentials: "include",
            }
        );

        if (response.ok) {
            const data = await response.json();
            return { success: true, data, message: "Admin invited!" };
        } else if (response.status === 400) {
            return {
                success: false,
                error: "The provided email is already taken. Please use another one."
            };
        } else {
            return { success: false, error: "Failed to invite admin" };
        }
    } catch (error) {
        console.error("Error inviting admin:", error);
        return {
            success: false,
            error: "Failed to invite admin. Please check your network connection and try again."
        };
    }
};

export const deleteAdmin = async (adminId) => {
    return apiDelete({ endpoint: `${process.env.REACT_APP_API_URL}/admins/${adminId}`, successMessage: "Admin deleted!", error_message: "Failed to delete admin" });
};

export const updateAdmin = async (adminId, adminData) => {
    return apiPut({ endpoint: `${process.env.REACT_APP_API_URL}/admins/${adminId}`, body: adminData, successMessage: "Admin updated!", errorMessage: "Failed to update admin" })
};